<template>
	<div id="dg" v-if="loaded">
		<div v-html="dgcontent"></div>
	</div>
</template>

<script>

export default {
  data () {
    return {
		loaded:false,
		dgcontent:''
	}
  },
  mounted () {
  },
  created(){
	this.loaded = true
	this.dgcontent = this.$store.state.config.data.dgcontent
  },
  methods: {
	  	
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#dg{
		background-color:#f4fcff;
		min-height:100vh;
	}
	img{
		max-width:100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/Dg.vue